import { Controller } from 'stimulus';
import { useDispatch, useWindowResize } from 'stimulus-use';
import Swiper, { Pagination, Mousewheel } from 'swiper'; 
import { getBreakpointValue, isMinBreakpoint } from '../tailwindhelpers'; 

Swiper.use([Pagination, Mousewheel]);

export default class extends Controller {
  initialize() {
    this.swiper = new Swiper('.home-slider', { 
      init: false,
      spaceBetween: 0,
      direction: 'vertical',
      slidesPerView: 1,
      mousewheel: {
        eventsTarget: '.scrollable',
      },
    }); 
  }

  connect() { 
    useDispatch(this);
    useWindowResize(this);

    this.swiper.init();
    this.dispatch('hsinit');
  }

  windowResize({height, width}) {
    this.swiper.height = window.screenHeight;

    if (isMinBreakpoint(width, 'lg')) {
      this.disableTouch();
    } else {
      this.enableTouch();
    }
  }

  disableTouch() {
      //this.swiper.allowSlideNext = false;
      //this.swiper.allowSlidePrev = false;
      this.swiper.allowTouchMove = false;
  }

  enableTouch() {
      //this.swiper.allowSlideNext = true;
      //this.swiper.allowSlidePrev = true;
      this.swiper.allowTouchMove = true;
  }

  next(e) {
    this.swiper.slideNext();
    //window.dispatchEvent(new Event('home:slidechange'));
    this.fakeMousemove(e);
  }

  prev(e) {
    this.swiper.slidePrev();
    //window.dispatchEvent(new Event('home:slidechange'));
    this.fakeMousemove(e);
  }

  fakeMousemove(e) {
    const fakeDetail = {
      pageX: e.detail.pageX,
      pageY: e.detail.pageY,
      direction: e.detail.controller.direction
    }
    this.element.querySelectorAll('[data-controller*="hover"').forEach(el => {
      const hoverController = this.application.getControllerForElementAndIdentifier(el, 'hover');
      hoverController.addCursor();
      hoverController.moveCursor(fakeDetail);
      el.dispatchEvent(new Event('mousemove'));
    })
  }
}